const getters = {
  token: state => state.home.Token,
  nick: state => state.home.Nick,
  UserInfo: state => state.home.UserInfo,
  MemberInfo: state => state.home.MemberInfo,
  Sign: state => state.home.Sign,
  billInfo: state => state.service.billInfo,
}
export default getters
